export default {
  // Common
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.add": "Add",
  "common.back": "Back",
  "common.loading": "Loading...",
  "common.error": "Something went wrong",
  "common.success": "Success",
  "common.confirm": "Confirm",
  "common.search": "Search",
  "common.filter": "Filter",
  "common.all": "All",
  "common.comingSoon": "Coming soon",
  "common.noResults": "No results found",
  "common.retry": "Retry",

  // Auth
  "auth.login": "Log In",
  "auth.signup": "Sign Up",
  "auth.logout": "Sign Out",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Full Name",
  "auth.confirmPassword": "Confirm Password",
  "auth.forgotPassword": "Forgot password?",
  "auth.noAccount": "Don't have an account?",
  "auth.haveAccount": "Already have an account?",
  "auth.demoHint": "Use demo@payflow.ai / demo123 to try",
  "auth.agreeTerms": "I agree to the Terms of Service and Privacy Policy",

  // Dashboard
  "dashboard.title": "Dashboard",
  "dashboard.greeting": "Good morning",
  "dashboard.totalDue": "Total Due",
  "dashboard.thisMonth": "This Month",
  "dashboard.upcomingPayments": "Upcoming Payments",
  "dashboard.quickStats": "Quick Stats",
  "dashboard.noUpcoming": "No upcoming payments",
  "dashboard.addFirst": "Add your first payment to get started",
  "dashboard.budgetUsed": "Budget Used",

  // Payments
  "payments.title": "Payments",
  "payments.add": "Add Payment",
  "payments.edit": "Edit Payment",
  "payments.detail": "Payment Detail",
  "payments.amount": "Amount",
  "payments.dueDate": "Due Date",
  "payments.category": "Category",
  "payments.frequency": "Frequency",
  "payments.notes": "Notes",
  "payments.status.paid": "Paid",
  "payments.status.pending": "Pending",
  "payments.status.overdue": "Overdue",
  "payments.markAsPaid": "Mark as Paid",
  "payments.deleteConfirm": "Are you sure you want to delete this payment?",
  "payments.frequency.once": "One Time",
  "payments.frequency.weekly": "Weekly",
  "payments.frequency.monthly": "Monthly",
  "payments.frequency.yearly": "Yearly",
  "payments.noPayments": "No payments yet",

  // Subscriptions
  "subscriptions.title": "Subscriptions",
  "subscriptions.add": "Add Subscription",
  "subscriptions.monthly": "Monthly Spend",
  "subscriptions.active": "Active",
  "subscriptions.paused": "Paused",
  "subscriptions.overdue": "Overdue",
  "subscriptions.nextBilling": "Next billing",
  "subscriptions.billingCycle": "Billing Cycle",

  // Analytics
  "analytics.title": "Analytics",
  "analytics.spendingByCategory": "Spending by Category",
  "analytics.monthlyTrend": "Monthly Trend",
  "analytics.totalSpent": "Total Spent",
  "analytics.paidThisMonth": "Paid This Month",
  "analytics.pending": "Pending",
  "analytics.noData": "No data for this period",

  // Nav
  "nav.home": "Home",
  "nav.payments": "Payments",
  "nav.add": "Add",
  "nav.analytics": "Analytics",
  "nav.profile": "Profile",
  "nav.allPayments": "All Payments",
  "nav.addPayment": "Add Payment",
  "nav.subscriptions": "Subscriptions",
  "nav.calendar": "Calendar",
  "nav.documents": "Documents",
  "nav.settings": "Settings",
  "nav.personalInfo": "Personal Info",
  "nav.changePassword": "Change Password",
  "nav.twoFactor": "Two-Factor Auth",
  "nav.devices": "Devices",
  "nav.reminders": "Reminders",
  "nav.editPayment": "Edit Payment",
  "nav.paymentDetail": "Payment Detail",

  // Notifications
  "notifications.title": "Notifications",
  "notifications.none": "No new notifications",
  "notifications.viewAll": "View all payments",
  "notifications.overdue": "is overdue",
  "notifications.dueToday": "is due today",
  "notifications.dueSoon": "due in",
  "notifications.days": "days",

  // Calendar
  "calendar.title": "Calendar",
  "calendar.export": "Export Calendar (.ics)",
  "calendar.openGoogle": "Open Google Calendar",
  "calendar.sync": "Calendar Sync",
  "calendar.noPaymentsToday": "No payments on this date",
  "calendar.connectGoogle": "Connect Google Calendar",

  // Documents
  "documents.title": "Documents",
  "documents.upload": "Upload Document",
  "documents.noDocuments": "No documents uploaded",
  "documents.maxSize": "Max 10MB — PDF, JPEG, PNG",

  // Profile
  "profile.title": "Profile",
  "profile.settings": "Settings",
  "profile.reminders": "Reminders",
  "profile.personalInfo": "Personal Information",
  "profile.changePassword": "Change Password",
  "profile.twoFactor": "Two-Factor Authentication",
  "profile.connectedDevices": "Connected Devices",
  "profile.devices": "Devices",
  "profile.language": "Language",
  "profile.deleteAccount": "Delete Account",
  "settings.selectLanguage": "Select Language",
  "profile.plan.free": "Free Plan",
  "profile.plan.pro": "Pro Plan",
  "profile.upgradeToPro": "Upgrade to Pro",

  // Reminders
  "reminders.title": "Reminder Preferences",
  "reminders.daysBefore": "Remind me before",
  "reminders.email": "Email Notifications",
  "reminders.push": "Push Notifications",
  "reminders.sms": "SMS Notifications",

  // Errors
  "error.required": "This field is required",
  "error.invalidEmail": "Invalid email address",
  "error.passwordTooShort": "Password must be at least 6 characters",
  "error.passwordMismatch": "Passwords do not match",
  "error.networkError": "Network error. Please check your connection.",
  "error.unauthorized": "Session expired. Please log in again.",
  "error.notFound": "Page not found",
};
